import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { BaseQueryFn, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { pca } from '../main';

export const getAccessToken = async (): Promise<string | undefined> => {
  let account = pca.getActiveAccount();
  if (!account) {
    account = pca.getAllAccounts()[0];
  }

  if (account) {
    try {
      const response = await pca.acquireTokenSilent({
        scopes: ['api://' + import.meta.env.VITE_UENBPQ_API_CLIENT_ID + '/access_as_user'],
        account: account,
      });

      if (response) {
        return response.accessToken;
      }
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        pca.acquireTokenRedirect({
          scopes: ['api://' + import.meta.env.VITE_UENBPQ_API_CLIENT_ID + '/access_as_user'],
          account: account,
        });
        //acquireTokenRedirect redirects the page, so the following code will not execute
        return undefined;
      }
      throw error;
    }
  }
};

const customBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
  const baseQuery = await fetchBaseQuery({
    baseUrl: import.meta.env.VITE_UENBPQ_API,
    prepareHeaders: async (headers) => {
      const accessToken = await getAccessToken();
      if (accessToken) {
        headers.set('Authorization', 'Bearer ' + accessToken);
      }
      headers.set('content-type', 'application/json');
      return headers;
    },
    responseHandler: async (response) => {
      const contentType = response.headers.get('content-type') ?? '';

      if (contentType.includes('application/octet-stream')) {
        return await response.blob();
      }

      if (contentType.includes('application/json')) {
        return await response.json();
      }

      return await response.text();
    },
  });

  return baseQuery(args, api, extraOptions);
};

export const combinedApi = createApi({
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
});
